module.exports = __webpack_public_path__ + "static/media/orange@2x.2605e8ca.png";